import { useState, useEffect, useLayoutEffect, useMemo } from 'react';

import api from '../../../apis';

import FormInput from '../../general/form-control/form-item/input';

import property from '../../../constants/property';
import { Button, Divider } from 'antd';
import { showMessageModal, showSuccessMessageModal } from '../../../components/utils';

const manualTransferType = property.manualTransferType;

const ChangeSecretAnswerForm = ({
    onSuccess = () => {}
}) => {
    const [loading, setLoading] = useState(false);
    const [inputs, setInputs] = useState<any>({});
    const [errors, setErrors] = useState<any>({});

    //validation settings
    const [rules, setRules] = useState<any>({

        password: {
            required: true,
            error_message: 'Please input new password'
        },
        question1: {
            required: true,
            error_message: 'Please input answer'
        },
        question2: {
            required: true,
            error_message: 'Please input answer'
        },
        question3: {
            required: true,
            error_message: 'Please input answer'
        },
        // re_new_password: {
        //     required: true,
        //     same_value: 'new_password',
        //     same_value_error_message:
        //         'New password and confirm password not match',
        //     error_message: 'Please input confirm password'
        // }
    });


    const onInputChange = (id: string, newValue: string) => {
        setInputs((prevState: any) => ({
            ...prevState,
            [id]: newValue
        }));
    };

    const formValidation = (rules: any, inputs: any) => {
        if (!rules) return { valid: true, errors: {} };

        let valid = true;
        let errors: any = {};

        //validate rule
        for (var key in rules) {
            if (rules.hasOwnProperty(key)) {
                let item = rules[key];
                if (item.required == true && !inputs[key]) {
                    let error = item.error_message || 'Required';
                    errors[key] = error;
                    valid = false;
                } else if (item.requireIfExist) {
                    //if specific input exist,current input become required
                    let requireIfExist = item.requireIfExist;
                    let relatedkey = requireIfExist.key;
                    let relatedValue = requireIfExist.value;

                    //match type start check error
                    if (
                        relatedkey &&
                        relatedValue &&
                        inputs[relatedkey] &&
                        inputs[relatedkey] == relatedValue
                    ) {
                        if (!inputs[key]) {
                            let error = item.error_message || 'Required';
                            errors[key] = error;
                            valid = false;
                        }
                    }
                } //match value with
                if (item.same_value && inputs[key]) {
                    let same_value = item.same_value;

                    if (inputs[key] != inputs[same_value]) {
                        let error = item.same_value_error_message || 'Required';
                        errors[key] = error;
                        valid = false;
                    }
                } else {
                }

                // requireIfExist: { key: 'mode', value: 2 }
            }
        }

        return {
            valid,
            errors
        };
    };

    const handleSubmit = async (e: any) => {
        e.preventDefault();

    
        setLoading(true);
        let { valid, errors } = formValidation(rules, inputs);
        setErrors(errors);
        console.log(errors);
        if (valid == false) {
            //scroll to first error
            if (Object.keys(errors).length > 0) {
                let firstKey = Object.keys(errors)[0];
                let element = document.getElementById(firstKey);
                element?.scrollIntoView();
            }
            setLoading(false);
        } else {
            setLoading(true);
            
            let answers = [inputs.question1,inputs.question2,inputs.question3];
            inputs.answers = answers;
           // console.log("inputs",inputs);

            let result = await api.changeSecretAnswer(inputs);
            if (result.status == 0) {
                //alert('Secret Answer changed successfully');
                showSuccessMessageModal('Secret Answer changed successfully');
                //if (props.setModelOpen) props.setModelOpen(false);

                if(onSuccess){
                    onSuccess();
                }
            } else if (result.status == 1) {
                let message = result?.message;

                if (message) {
                    if (typeof message === 'string') {
                       // alert(message);
                        showMessageModal(message);
                    } else {
                        let text = '';
                        for (var key in message) {
                            if (message.hasOwnProperty(key)) {
                                let sentence = message[key];
                                if (key == 'new_password') {
                                    sentence = sentence.replace(
                                        '"new_password"',
                                        'New password'
                                    );
                                }
                                text += sentence + '\n';
                            }
                        }
                       // alert(text);
                        showMessageModal(text);
                    }
                }
            }
            //console.log('changePassword', result);

            setLoading(false);
 
        }


    };
   
   return (<>
        <form>
            <div className="row ">
                <div className="col-xxxl-12 col-xl-12 col-lg-12 col-md-12 col-12">
                    <div className=''>Update Security Questions</div>
                </div>
            </div>
            <div className="row pt-2">
                <div className="col-xxxl-12 col-xl-12 col-lg-12 col-md-12 col-12">
                    <div className="form-input-container ">
                        <div className="label">Current Password:</div>
                        <FormInput
                            id="password"
                            type="password"
                            value={inputs.password || ''}
                            onChange={({ target }: any) =>
                                onInputChange(target.id, target.value)
                            }
                            error={errors.password}
                        />
                    </div>
                </div>
            </div>
            <Divider  />
            <div className="row ">
                <div className="col-xxxl-12 col-xl-12 col-lg-12 col-md-12 col-12">
                    <div className=''>Key in your new Answer below.</div>
                </div>
            </div>
           
            <div className="row ">
                <div className="col-xxxl-12 col-xl-12 col-lg-12 col-md-12 col-12">
                    <div className="form-input-container ">
                        <div className="label">Question 1: What is your mother's maiden name?</div>
                        <FormInput
                            id="question1"
                            type="question1"
                            value={inputs.question1 || ''}
                            onChange={({ target }: any) =>
                                onInputChange(target.id, target.value)
                            }
                            error={errors.question1}
                        />
                    </div>
                </div>
            </div>
            <div className="row ">
                <div className="col-xxxl-12 col-xl-12 col-lg-12 col-md-12 col-12">
                    <div className="form-input-container ">
                        <div className="label">Question 2: What is your favourite past time?*</div>
                        <FormInput
                            id="question2"
                            type="question2"
                            value={inputs.question2 || ''}
                            onChange={({ target }: any) =>
                                onInputChange(target.id, target.value)
                            }
                            error={errors.question2}
                        />
                    </div>
                </div>
            </div>
            <div className="row ">
                <div className="col-xxxl-12 col-xl-12 col-lg-12 col-md-12 col-12">
                    <div className="form-input-container ">
                        <div className="label">Question 3: What was your first job after school?</div>
                        <FormInput
                            id="question3"
                            type="question3"
                            value={inputs.question3 || ''}
                            onChange={({ target }: any) =>
                                onInputChange(target.id, target.value)
                            }
                            error={errors.question3}
                        />
                    </div>
                </div>
            </div>
            <Divider  />
            <div>
                <Button type="primary" onClick={(e)=>handleSubmit(e)} className='btn-primary-custom btn-md' loading={loading}>
                    Change
                </Button>
            </div>
        </form>
   </>)
};

export default ChangeSecretAnswerForm;
